/* eslint-disable import/no-cycle */
import utils from "Root/profile/utils";
import { useSelector } from "react-redux";
export const _getQuanityString = (qty, item_type, servings, sku) => {
    if (sku === "high_nocaff_mango_10") {
        return "1 Pack | 10 servings";
    }
    if (utils.isFlavorBoost(item_type)) {
        return `${qty} Pack${qty > 1 ? "s" : ""} | ${7 * Number(qty)} servings`;
    }
    if (["creatine", "preworkout", "collagen", "fiber"].includes(item_type)) {
        return `${qty} Jar${qty > 1 ? "s" : ""} | ${servings} servings`;
    }
    if (["greens"].includes(item_type)) {
        return `${qty} Box${qty > 1 ? "es" : ""} | ${servings} servings`;
    }
    return `${qty} Bag${qty > 1 ? "s" : ""} | ${servings} servings`;
};
export const _getTitle = (title, item_type) => {
    if (utils.getIsBooster(item_type)) {
        return title.replace("Performance Boosts", "");
    }
    return title;
};
export const _getCategory = (item_type, isByb, sku) => {
    if (sku === "high_nocaff_mango_10") {
        return "Free Gift";
    }
    if (utils.isFlavorBoost(item_type)) {
        return "Flavor Boost";
    }
    if (utils.isAdditionalItem(item_type)) {
        return "Accessory";
    }
    if (utils.getIsBooster(item_type)) {
        return "Performance Boost";
    }
    return item_type === "greens" ? "" : !isByb ? "Personalized" : "Customized";
};
export const _getFlavorString = (available_flavors, bags_info) => {
    const bagsFlavors = bags_info
        .map((item) => item.selected_flavors.filter((f) => f.count).map((f) => f.short_name))
        .flat();
    const flavorString = available_flavors
        .map((item) => {
        const bagFlavor = bagsFlavors.find((f) => f === item.short_name);
        if (bagFlavor) {
            return item.full_name;
        }
        return "";
    })
        .filter((item) => item);
    return flavorString.length > 0 ? flavorString.join(", ") : "No Flavors";
};
export const _getAttributeString = (bags_info) => {
    const bagsAttr = bags_info.map((item) => {
        const attr = item.attributes
            .map((a) => (a.attribute_on ? a.attribute_on_text : a.attribute_off_text))
            .join(" + ");
        return attr;
    });
    return bagsAttr.join(", ");
};
const useSubscriptionItem = ({ item_type, available_flavors, attributes, onClick, bags_info, servings, title, delivery_cadence, flavor_attribute_description, }) => {
    const isProtein = item_type === "protein";
    const isByb = useSelector((state) => state.user.user_class === "byb");
    const hasFlavors = !!available_flavors.length;
    const isAdditionalItemOrFb = utils.isFlavorBoost(item_type) || utils.isAdditionalItem(item_type);
    const hasAttributes = !!attributes.length;
    const onItemClick = (id) => {
        id !== "target_hydration" &&
            id !== "other" &&
            !isAdditionalItemOrFb &&
            onClick &&
            onClick(id);
    };
    const getAtrributesString = () => {
        return flavor_attribute_description;
    };
    const getFlavorString = () => {
        return _getFlavorString(available_flavors, bags_info);
    };
    const getQuanityString = (qty) => _getQuanityString(qty, item_type, servings);
    const getCategory = () => _getCategory(item_type, isByb);
    const getTitle = () => _getTitle(title, item_type);
    const blenderBottleString = item_type === "blenderbottle" && `20 oz. | ${delivery_cadence}`;
    const waterbottleString = (item_type === "wb221" || item_type === "wb222") &&
        `22 oz. | ${delivery_cadence}`;
    return {
        blenderBottleString,
        waterbottleString,
        getTitle,
        getCategory,
        getQuanityString,
        getFlavorString,
        getAtrributesString,
        onItemClick,
        isProtein,
        hasFlavors,
        hasAttributes,
        isAdditionalItemOrFb,
    };
};
export default useSubscriptionItem;
